import { RouteConfig } from 'vue-router'
import MasterLayout from '@/components/layouts/MasterLayoutComponent.vue'

const routes: Array<RouteConfig> = [
  {
    path: '/admin/SendMoney',
    name: 'SendMoney',
    component: () => import(/* webpackChunkName: "EWSendMoney" */ '../views/EWSendMoney/EWSendMoney.vue'),
    meta: { requireAuth: true, layout: MasterLayout }
  },
  {
    path: '/admin/ReceiveMoney',
    name: 'ReceiveMoney',
    component: () => import(/* webpackChunkName: "EWReceiveMoney" */ '../views/EWReceiveMoney/EWReceiveMoney.vue'),
    meta: { requireAuth: true, layout: MasterLayout }
  },
  {
    path: '/admin/CashInMoney',
    name: 'CashInMoney',
    component: () => import(/* webpackChunkName: "EWCashInMoney" */ '../views/EWCashInMoney/EWCashInMoney.vue'),
    meta: { requireAuth: true, layout: MasterLayout }
  },
  {
    path: '/admin/AddMoney',
    name: 'AddMoney',
    component: () => import(/* webpackChunkName: "EWAddMoney" */ '../views/EWAddMoney/EWAddMoney.vue'),
    meta: { requireAuth: true, layout: MasterLayout }
  },
  {
    path: '/admin/MakePayment',
    name: 'MakePayment',
    component: () => import(/* webpackChunkName: "EWAddMoney" */ '../views/EWMakePayment/EWMakePayment.vue'),
    meta: { requireAuth: true, layout: MasterLayout }
  },
  {
    path: '/admin/statement',
    name: 'Statement',
    component: () => import(/* webpackChunkName: "EWAddMoney" */ '../views/EWTransactionStatement/EWTransactionStatement.vue'),
    meta: { requireAuth: true, layout: MasterLayout }
  }
]

export default routes
